import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@ui/Table'

import { getContactHeaders } from '@models/admin/organizationContacts'
import DeleteDialog from '@ui/DeleteDialog'
import httpService from '@services/httpService'
import styles from '@styles/indexPage'

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isDialogOpen: false,
      id: null
    }

    this.closeDialog = this.closeDialog.bind(this)
  }

  closeDialog() {
    this.setState({ isDialogOpen: false })
  }

  handleDelete = async (organizationId) => {
    const { o } = this.props

    try {
      await httpService.delete(
        `/v4/o/${o}/admin/organizations/${organizationId}/contacts/${this.state.id}.json`
      )

      Turbolinks.visit(`/v4/o/${o}/admin/organizations/${organizationId}/contacts`)
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    const { model, classes, organization, o } = this.props
    const { isDialogOpen } = this.state

    return (
      <Paper className={classes.page__wrapper} elevation={0}>
        <header className={classes.page__header}>
          <Typography component='h2' variant='h5'>
            {I18n.t('v4/organization_contact.title')}
          </Typography>
        </header>

        <Button
          variant='outlined'
          color='primary'
          className={classes.page__newResourceButton}
          href={`/v4/o/${o}/admin/organizations/${organization.id}/contacts/new`}
        >
          {I18n.t('v4/organization_contact.actions.new')}
        </Button>

        <Table
          tableKey='admin-organizations-contacts-index'
          components={{
            Container: props => <div>{props.children}</div>
          }}
          columns={getContactHeaders()}
          data={model}
          actions={[
            rowData => ({
              icon: 'create',
              iconProps: { 'data-testid': `edit-${rowData.id}` },
              tooltip: I18n.t('actions.edit'),
              onClick: (event, rowData) => {
                Turbolinks.visit(
                  `/v4/o/${o}/admin/organizations/${organization.id}/contacts/${rowData.id}/edit`
                )
              }
            }),
            rowData => ({
              icon: 'delete',
              iconProps: { 'data-testid': `delete-${rowData.id}` },
              tooltip: I18n.t('actions.remove'),
              onClick: (event, rowData) => {
                this.setState({ isDialogOpen: true, id: rowData.id })
              }
            })
          ]}
          options={{ showTitle: false }}
        />

        <DeleteDialog
          dialogTitle={`${I18n.t('actions.remove')} ${I18n.t('v4/organization_contact.one')}?`}
          dialogText={I18n.t('v4/organization_contact.confirmation.remove')}
          handleDelete={() => this.handleDelete(organization.id)}
          onCancel={this.closeDialog}
          onClose={this.closeDialog}
          open={isDialogOpen}
        />
      </Paper>
    )
  }
}

Index.propTypes = {
  model: PropTypes.array,
  organization: PropTypes.object,
  o: PropTypes.string
}

export default withStyles(styles)(Index)
